// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { Flex } from '@atlassian/eoc-flex';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div({
	background: token('elevation.surface', '#ffffff'),
	boxShadow: token(
		'elevation.shadow.raised',
		'0px 0px 1px rgba(9, 30, 66, 0.31), 0px 1px 1px rgba(9, 30, 66, 0.25)',
	),
	borderRadius: token('border.radius.100', '3px'),
	padding: token('space.150', '12px'),
	zIndex: 1,
	position: 'relative',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Row = styled.div({
	display: 'grid',
	gridTemplateColumns: '0.3fr repeat(2, 1fr)',
	gridColumnGap: token('space.150', '12px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&:not(:first-of-type)': {
		marginTop: token('space.100', '8px'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ErrorMessageWrapper = styled.div({
	gridColumn: '2 span',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MinuteContainer = styled.div({
	display: 'grid',
	gridTemplateColumns: '0.35fr 1fr',
	gridColumnGap: token('space.150', '12px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	"input::-webkit-outer-spin-button, input::-webkit-inner-spin-button, input[type='number']": {
		WebkitAppearance: 'none',
		MozAppearance: 'textfield',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const Text = styled.span({
	font: token('font.body.UNSAFE_small'),
	fontWeight: token('font.weight.semibold'),
	color: token('color.text.subtlest'),
	marginTop: 0,
	display: 'flex',
	height: '40px',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ActionButtons = styled.div({
	display: 'flex',
	justifyContent: 'flex-end',
	margin: `${token('space.100', '8px')} 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const WarningMessageWrapper = styled(Flex)({
	alignItems: 'center',
	color: token('color.text.subtlest', N300),
	marginRight: token('space.300', '24px'),
});
